import { Form } from "@client/content/controls";
import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps, type FormFieldInfo } from "@client/controls/Form/component";
import Loading from "@client/controls/Loading/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { getEmailFromQS, getTypeFromQS } from "../lib";
import { type Unsubscribe } from "../types";

export interface UnsubscribeFormData {
  email: string;
  action: Unsubscribe.UnsubscribeAction;
  isInstant: boolean;
  reason: Unsubscribe.UnsubscribeReason;
}

export type UnsubscribeMapProps = RootContainerProps & {
  buttonStyle: React.CSSProperties;
  fields: FormFieldInfo[];
  status: string;
};

export interface UnsubscribeActionProps {
  unsubscribe: (data: UnsubscribeFormData) => void;
}

export type UnsubscribeProps = UnsubscribeActionProps & UnsubscribeMapProps;

export default (props: UnsubscribeProps) => {
  const i18n = useI18n();

  const FormButton = React.useCallback(
    (innerProps: FormButtonProps) => (
      <ModuleButton
        {...getRootContainerProps(props)}
        isDisabled={props.status === "Unsubscribing"}
        onClick={innerProps.ifValidated(props.unsubscribe)}
      />
    ),
    [props.buttonStyle, props.status, props.unsubscribe]
  );

  React.useEffect(() => {
    if (getTypeFromQS() === "instant" && getEmailFromQS()) {
      props.unsubscribe({
        action: "all",
        email: getEmailFromQS()!,
        isInstant: true,
        reason: "Unsubscribe"
      });
    }
  }, []);

  if (props.status === "UnsubscribingInstant") return <Loading />;

  return (
    <>
      <h3>{i18n.unsubscribe}</h3>
      <Form {...getRootContainerProps(props)} fields={props.fields} Button={FormButton} />
    </>
  );
};
